import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components'

import { useDispatch, useSelector } from 'react-redux'
import { getLandingPage } from '../../../../pages/features/landingpage/landingpageSlice'

// import { 
//     BoxContainer,
//     ImageContainer,
//     TextContainer,
//  } from '../../../../components/postCard'



import { PostCard } from '../../../../components/postCard'
import { 
    Container,
    HeaderContainer,
    NavLink 
} from '../popularcategories'

const RecentlyAdded = () => {


    const dispatch = useDispatch

    const { landingPage, landingStatus} = useSelector(state => state?.landingPage);

    // useEffect(() => {

    //     dispatch(getLandingPage());

    // }, [landingStatus]);


  return (
    <Container>
        <HeaderContainer>
            <h2>New Arrivals</h2>
            <h5> <NavLink to='/nigeriana' >View all</NavLink> </h5>

            
        </HeaderContainer>
        <CardsContainer>

            {
                landingPage?.recentlyCreatedInternalResources?.slice(0, 12)?.map((popular) => {
                    return(
                        <LinkToDetails key={popular?.resourceId} to={`/nigeriana/resource/${popular.resourceNlnCode}`} >
                        <BoxContainer>
                            
                            <ImageContainer src={popular?.resourceImage} />
                            <TextContainer>
                                <h5>
                                {popular?.resourceTitle?.substring(0, 50) + '...'}
                                </h5>
                                <small>by {popular?.resourceAuthor}</small>
                            </TextContainer>
                            
                        </BoxContainer>
                        </LinkToDetails>
                    )
                })
            }
            

        </CardsContainer>
    </Container>
  )
}

const CardsContainer = styled.div`
    width: 100%;
    max-width: 1250px;
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    flex-direction: row;
    justify-content: space-between;
    /* flex-wrap: wrap; */
    margin-top: 20px;

    @media screen and (max-width: 600px){
            justify-content: center;
            display: flex;
            flex-wrap: wrap;

        }
    
`;

export const BoxContainer = styled.div`
    width: 200px;
    /* width: 254px; */
    display: flex;
    padding-top: 10px;
    flex-direction: column;
    cursor: pointer;

    @media screen and (max-width: 600px){
        width: 300px;
    }
`

const LinkToDetails = styled(Link)`
    text-decoration: none;
    color: #000;
`

export const ImageContainer = styled.img`
    width: inherit;
    height: 254px;
    object-fit: fill;
    border-radius: 4px 4px 0px 0px;

    @media screen and (max-width: 600px){
        width: 300px;
    }

    :hover{
        opacity: 0.8;
        transition: 0.5s;
    }
`
export const TextContainer =  styled.div`
    padding: 10px 20px;
    width: 100%;
    text-align: left;
    box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 0 0 4px 4px;
    

    & > h5{
        width: 100%;
        
        /* font-size: 14px; */
    }

`



export {RecentlyAdded}